var Backbone, StepTwoSearchBoxTemplate, SupportSearchInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

StepTwoSearchBoxTemplate = require('../../step_two_search_box.html.mustache');

SupportSearchInputView = (function(superClass) {
  extend(SupportSearchInputView, superClass);

  function SupportSearchInputView() {
    return SupportSearchInputView.__super__.constructor.apply(this, arguments);
  }

  SupportSearchInputView.prototype.template = StepTwoSearchBoxTemplate;

  SupportSearchInputView.prototype.initialize = function() {
    return this.I18nScope = 'modules.support';
  };

  SupportSearchInputView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportSearchInputView.prototype.toHash = function() {
    return {
      searchInputDefaultText: I18n.t("js.modules.support.search_input_default_text")
    };
  };

  return SupportSearchInputView;

})(Backbone.View);

module.exports = SupportSearchInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvc2VhcmNoX2lucHV0X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvc2VhcmNoX2lucHV0X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsMERBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2Isd0JBQUEsR0FBMkIsT0FBQSxDQUFRLHlDQUFSOztBQUVyQjs7Ozs7OzttQ0FDSixRQUFBLEdBQVc7O21DQUVYLFVBQUEsR0FBWSxTQUFBO1dBQ1YsSUFBQyxDQUFBLFNBQUQsR0FBYTtFQURIOzttQ0FHWixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWxCLEVBQTZCLElBQUMsQ0FBQSxTQUE5QixDQUFaO0VBRE07O21DQUdSLE1BQUEsR0FBUSxTQUFBO1dBQ047TUFBQSxzQkFBQSxFQUF5QixJQUFJLENBQUMsQ0FBTCxDQUFPLDhDQUFQLENBQXpCOztFQURNOzs7O0dBVDJCLFFBQVEsQ0FBQzs7QUFZOUMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
